import { PageHeaderMini } from 'components/eventView/layout/PageHeaderMini';
import { EventViewEntityListPageContent } from 'components/eventView/pages/EVEntityListPageContent';
import { StickyHeaderLayout } from 'elements/eventView/layout/StickyHeaderLayout';
import { motion } from 'framer-motion';
import { useContext } from 'react';
import { useParams } from 'react-router';
import { CtxEventView } from 'session/ctxEventView';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
    entity: 'program';
}

export const EVDetailListPageMobile = (props: Props) => {
    const { entityId } = useParams() as { entityId: string };
    const ctxEventView = useContext(CtxEventView);

    const getTitle = () => {
        if (props.entity === 'program') {
            return ctxEventView.allPrograms.find((e) => e.programId === entityId)?.title;
        }
    };

    const title = getTitle();

    return (
        <S_EVDetailListPageMobile className={props.className}>
            <StickyHeaderLayout>
                <PageHeaderMini>{title}</PageHeaderMini>
            </StickyHeaderLayout>
            <S_EVEntityListPageContent entityId={entityId} entity={props.entity} />
        </S_EVDetailListPageMobile>
    );
};

const S_EVDetailListPageMobile = styled(motion.div)`
    position: absolute;
    top: 0;
    padding-top: 70px;
    bottom: 0;
    height: 100vh;
    width: 100%;
    overflow-y: auto;
    overflow-x: hidden;
    padding-bottom: 78px;
    background: #f1f2f4;
`;

const S_EVEntityListPageContent = styled(EventViewEntityListPageContent)`
    position: fixed;
    top: 0;
    bottom: 0;
    height: 100vh;
    overflow-y: auto;
    overflow-x: hidden;
    padding: 85px 10px 150px 10px;
`;
